import React, { useEffect, useState } from 'react';
import { AppContext } from '../../App';
import Loader from '../../common/Loader';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useFetchTournamentData } from '../../data/useFetchTournamentData';
import { getPrincipaleOPrimoGruppo } from '../../data/utils/getPrincipaleOPrimoGruppo';
import { getPrincipaleOPrimoMacroGruppo } from '../../data/utils/getPrincipaleOPrimoMacroGruppo';
import { PrematchContext } from '../Prematch';
import Tournament from './Tournament';
import TournamentNavbar from './TournamentNavbar';

export const TournamentContext = React.createContext(null);

export function betsExpanded() {
    let expanded = true;
    const item = localStorage.getItem('xs_bets_expanded');
    if (item) {
        expanded = item === 'true';
    }
    return expanded;
}

function TournamentDataFetcher(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const cache = prematchContext.cache.tournaments;
    const tournament = props.data.tournamentByUniqueId[props.tournament];
    const tournamentBetGroup = getPrincipaleOPrimoGruppo(tournament.aggregate).idAggregata;
    const dataId = [tournament.uniqueId, tournamentBetGroup].join('_');

    const [state, setState] = useState({
        data: null,
        liveMatches: null,
        tournament,
        macrogruppo: null,
        aggregata: null,
        bet: null,
        macrogruppoFetch: null,
        aggregataFetch: tournamentBetGroup,
        dataNotCached: !cache.has(dataId),
        section: 'matches',
        expanded: betsExpanded(),
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setExpanded() {
            this.update({expanded: !this.expanded});
            localStorage.setItem('xs_bets_expanded', !this.expanded);
        },
        setData(data) {
            const dataId = [data.uniqueId, this.aggregataFetch].join('_');
            cache.set(dataId, data);
            let macrogruppo = this.macrogruppoFetch;
            if (macrogruppo == null) {
                macrogruppo = data.macrogruppi ? getPrincipaleOPrimoMacroGruppo(data.macrogruppi) : null;
            }
            this.update({data, macrogruppo, aggregata: this.aggregataFetch, bet: null});
        },
        setLiveMatches(liveMatches) {
            this.update({liveMatches});
        },
        changeTournament(tournament) {
            const aggregataFetch = getPrincipaleOPrimoGruppo(tournament.aggregate).idAggregata;
            const dataId = [tournament.uniqueId, aggregataFetch].join('_');
            if (cache.has(dataId)) {
                const data = cache.get(dataId);
                const macrogruppo = data.macrogruppi ? getPrincipaleOPrimoMacroGruppo(data.macrogruppi) : null;
                this.update({data, tournament, macrogruppo, aggregata: aggregataFetch, bet: null, macrogruppoFetch: null, aggregataFetch, dataNotCached: false});
            } else {
                this.update({tournament, macrogruppoFetch: null, aggregataFetch, dataNotCached: true});
            }
        },
        changeMacrogruppo(macrogruppo) {
            const macrogruppoFetch = this.data.macrogruppi.find(mg => mg.id === macrogruppo);
            const aggregataFetch = getPrincipaleOPrimoGruppo(macrogruppoFetch.aggregate).idAggregata;
            const dataId = [this.tournament.uniqueId, aggregataFetch].join('_');
            if (cache.has(dataId)) {
                this.update({data: cache.get(dataId), macrogruppo: macrogruppoFetch, aggregata: aggregataFetch, bet: null, macrogruppoFetch, aggregataFetch, dataNotCached: false});
            } else {
                this.update({macrogruppoFetch, aggregataFetch, dataNotCached: true});
            }
        },
        fetchData(aggregataFetch) {
            const dataId = [this.tournament.uniqueId, aggregataFetch].join('_');
            if (cache.has(dataId)) {
                this.update({data: cache.get(dataId), aggregata: aggregataFetch, bet: null, aggregataFetch, dataNotCached: false});
            } else {
                this.update({aggregataFetch, dataNotCached: true});
            }
        },
        changeBet(bet) {
            this.update({bet});
        },
        changeSection(section) {
            this.update({section});
        }
    });
    const [showLoader, setShowLoader] = useState(state.dataNotCached);
    const [request] = useFetchTournamentData(props.data, state.tournament, state.aggregataFetch, state.dataNotCached, false, true);

    useEffect(() => {
        if (state.tournament.id !== tournament.id || !state.dataNotCached) {
            state.changeTournament(tournament);
        }
    }, [props.tournament])

    useEffect(() => {
        let timeout = null;
        if (state.dataNotCached) {
            if (request.isLoading) {
                timeout = setTimeout(function() {
                    setShowLoader(true);
                }, 100);
            } else {
                clearTimeout(timeout);
                setShowLoader(false);
                if (!request.isError) {
                    state.setData(request.data);
                }
            }
        } else {
            setShowLoader(false);
        }

        return () => {
            clearTimeout(timeout);
        };
    }, [request]);

    const [openMatchFromPath, setOpenMatchFromPath] = useState(false);
    useEffect(() => {
        const data = state.data || cache.get(dataId);
        if(data && props.openFromPath && props.openFromPath.match){
            const match = data.events.find(function(e){return e.pal==props.openFromPath.match.pal && e.avv==props.openFromPath.match.avv});
            if((match||null)!==null){
                setOpenMatchFromPath(true);
                prematchContext.openMatchFromTournament({
                    ...data,
                    liveMatches: request.liveMatches
                }, match);
            }
            appContext.setHandleOpenFromPath(false);
        }
    }, [request.data, state.data, appContext.handleOpenFromPath]);

    if (state.data == null) {
        return <Loader error={request.isError} />;
    }

    if ((state.data.events.length === 0 && state.section !== 'outrights'))
        state.section = 'outrights';

    //Cambio da breadcumb da torneo proveniente da Outright verso un nuovo che non li contiene.
    if ((state.data.outrights.length === 0 && state.section === 'outrights'))
        state.section = 'matches';
        

    return (
        <TournamentContext.Provider value={state}>
            <SeoMetaTags />
            <div className="prematch-tournament">
                <TournamentNavbar {...props} {...state.data} />
                {showLoader || request.isError ?
                    <Loader error={request.isError} />
                    :
                    (!openMatchFromPath && 
                        <Tournament data={props.data} tournament={state.data} section={state.section} />
                    )
                }
            </div>
            <SeoMainContainer />
        </TournamentContext.Provider>
    );
}

export default TournamentDataFetcher;